module.exports = __webpack_public_path__ + "static/media/Default.95c59275.svg";